import './drawer_menu_styles.scss';

const DrawerMenu = ({children}) => {
    return <ul className="drawer-menu overflow-y-auto overflow-x-hidden ">{children}</ul>
}

export default DrawerMenu;